
import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function ShortListInformation() 
{
    const { setActionItem } = useCTAL();

    setActionItem();

    return ( 
        <> 
            <div class="alert alert-light mt-2" role="alert">
                <small>
                <p>Let's face it, Long Lists are cumbersome and intimidating.</p>
                <p>Short Lists are more manageable and usually contain the most important things you have on your plate.</p>
                
                <p>We recommend you use this Short List to clearly prioritize what you want to accomplish today or in the very near-term (ex. 5-7 items).</p>
                
                <p>You can easily move Actions from your private Long List or a shared Team List that you are either ready or almost ready to start. </p>

                <div class="mt-2">
                    <p>Good Luck and well ... keep it Short.</p>
                </div>

                </small>
            </div>
        </> 
    );
}

/*
alert-primary

If you are unable to continue, you can update the action item with your progress and/or any related file attachments and either release it 
                back to the List were you got it or re-assign it to another team-member.</p>


*/